<template>
	<div class="card border-dark mb-3" style="max-width: 18rem;">
		<div class="card-header">{{ account.wallet }}</div>
		<div class="card-body text-dark">
			<h5 class="card-title">Account ID : {{ account.accountId }}</h5>
			<p class="card-text">Private Key : {{ account.privateKey }}</p>
			<p class="card-text">Balance : {{ hBalance }}</p>
		</div>
	</div>
</template>

<script>
	import { accountGetBalance, accountGetInfo } from "@/service/accountInfo";

	export default {
		props: ['account'],
		data() {
			return {
				balance: '',
				message: ''
			}
		},
		computed: {
			hBalance() {
				return this.balance;
			}
		},
		methods: {
			async getInfo() {
				const tokenRelationships = await accountGetInfo(this.account.accountId);
				this.account.tokenRelationships = tokenRelationships;

				console.log(tokenRelationships);
				for(const key in tokenRelationships) {
					const relationship = tokenRelationships[key];
					console.log(relationship.hbarBalance);
				}
				this.balance = tokenRelationships.hbarBalance;
			},
			async getBalance() {
				const hbarBalance = await accountGetBalance(this.account.accountId);
				this.balance = hbarBalance;
			}
		},
		created() {
			// this.getInfo();
			this.getBalance();
		}
	}
</script>

<style scoped>

</style>